<script lang="ts" setup>
import { graphql } from '@/gql';
import PrivacyPolicyTemplate from '~/components/templates/PrivacyPolicyTemplate/PrivacyPolicyTemplate.vue';

const { data } = useAsyncQuery(
  graphql(`
    query PrivacyPolicyPage {
      term(type: PRIVACY_POLICY) {
        ...PrivacyPolicyTemplateTermRevision
      }
    }
  `)
);

useAppMeta({
  title: 'プライバシーポリシー',
});
</script>

<template>
  <PrivacyPolicyTemplate v-if="data" :term="data.term" />
</template>
